import type { SVGProps } from "react";
const SvgPkoBpLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="5.2 3.6 91 112.6"
    {...props}
  >
    <linearGradient id="PkoBpLogo_min_svg__a">
      <stop offset={0} stopColor="#004c9a" />
      <stop offset={0.14} stopColor="#004994" />
      <stop offset={0.33} stopColor="#013f84" />
      <stop offset={0.54} stopColor="#033069" />
      <stop offset={0.77} stopColor="#051a43" />
      <stop offset={1} stopColor="#070016" />
    </linearGradient>
    <radialGradient
      xlinkHref="#PkoBpLogo_min_svg__a"
      id="PkoBpLogo_min_svg__b"
      cx={49.9}
      cy={23.68}
      r={60.06}
      gradientUnits="userSpaceOnUse"
    />
    <radialGradient
      xlinkHref="#PkoBpLogo_min_svg__a"
      id="PkoBpLogo_min_svg__c"
      cx={49.9}
      cy={23.68}
      r={60.07}
      gradientUnits="userSpaceOnUse"
    />
    <radialGradient
      xlinkHref="#PkoBpLogo_min_svg__a"
      id="PkoBpLogo_min_svg__d"
      cx={49.9}
      cy={23.68}
      r={60.05}
      gradientUnits="userSpaceOnUse"
    />
    <path
      fill="#e4202c"
      d="M50.2 21a8.7 8.7 0 1 0-.01-17.41A8.7 8.7 0 0 0 50.2 21"
    />
    <path
      fill="url(#PkoBpLogo_min_svg__b)"
      d="M50.2 45.9c11.5 0 21.4-2.9 25.6-6.8 1.4-1.3 2.1-2.8 2.1-4.3s-.8-2.9-2.1-4.3c-1.4-1.3-3.4-2.5-5.9-3.5-5-2-12-3.3-19.7-3.3h-.1c-10.3 0-19.3 2.4-24.1 5.7-2.8 1.9-3.6 4.2-3.6 6.9v30.9c0 3.5 1 5 1.5 5.8q2.25 3.75 6 6l.2.1V42.4l.2.1c5.1 2.1 12.1 3.4 19.9 3.4M38.5 34.4c-.2-.2-.2-.5-.2-.6 0-.5.4-1.1 1-1.4.3-.2.7-.2 1-.2h20.3c.3 0 .7.1 1 .2.7.3 1 .9 1 1.4 0 .2-.1.4-.2.6-.3.3-.7.5-1.1.5H39.6c-.4 0-.9-.2-1.1-.5"
    />
    <path
      fill="url(#PkoBpLogo_min_svg__c)"
      d="M54.2 79.2v-8.8c0-2.7-2.2-4.8-4.9-4.9h-.1v-.8c2.8-.3 4.9-2.5 4.9-5.3v-6.2c0-1.4.1-2.8.5-4.1l.1-.2h-.2c-.7.1-1.9.1-3.2.1-1.9 0-4-.1-5.1-.2H46v.1c-.5 1.5-.7 2.8-.7 4.4v7c0 1.5-1.1 3.1-3.1 3.2V48.4h-.1c-3.4-.4-5.9-1-8.6-1.9l-.2-.1v34.5h.1c2.7 1.2 5.3 2 8.7 2.6h.1V66c1.9.1 3.1 1.6 3.1 3.2v9.6c0 2 .4 3.6.9 5.3v.1h.1c.7.1 1.8.1 3.1.1 1.8 0 3.9-.1 5.3-.3h.1v-.2c-.4-1.5-.6-2.9-.6-4.6"
    />
    <path
      fill="url(#PkoBpLogo_min_svg__d)"
      d="M77.1 45c0-.8-.7-1.5-1.5-1.5-.2 0-.5.1-.7.2-3.8 2.2-9.2 4-15.2 4.8a2.7 2.7 0 0 0-2.3 2.7v29.6c0 1.2 1 2.2 2.2 2.2.2 0 .3 0 .5-.1 4.7-1.2 8.7-3 11.9-5.6 2.8-2.4 5.1-5.7 5.1-9.5zm-7.7 7.4V73c0 .5-.3 1-.9 1.4-.8.5-1.7.5-2.1-.1-.1-.2-.1-.4-.1-.5V52.5c0-.5.5-1.1 1.2-1.3.2-.1.3-.1.5-.1.7 0 1.2.3 1.4.9v.3z"
    />
    <path d="M8.7 116.1c-2.4 0-3.5-.6-3.5-2.2v-9.4c0-2.5 2.3-2.4 3.4-2.4 3.4 0 4.7 1.5 4.7 3.3 0 1.7-1.2 2.7-2.5 3.2 1.7.3 3.3 1.4 3.3 3.6-.1 2-1.4 3.9-5.4 3.9m-.1-13c-.9 0-1.7.1-1.7 1.6v3.6h1.2c2 0 3.4-1 3.4-2.7 0-1.5-.9-2.5-2.9-2.5m-.4 6.1H6.9v4.5c0 1 .5 1.4 1.8 1.4 2.4 0 3.5-1.3 3.5-2.9 0-2-1.2-3-4-3m15.6 6.7c-.2 0-.5.1-.6.1-.4 0-.7-.2-.8-.8l-.1-.5h-.1c-.7.9-1.5 1.5-2.6 1.5-2.2 0-3.7-1.6-3.7-4.8 0-3.4 2.2-5.7 4.5-5.7 1.1 0 3.4.3 3.4 2zm-1.6-8.1c0-.8-.5-1.2-1.8-1.2-1.4 0-2.9 1.3-2.9 4.4 0 2.8 1.2 3.9 2.5 3.9 1 0 1.7-.6 2.2-1.2zm10.3 8.1v-7.2c0-1.1-.6-2.2-2.4-2.2-1.9 0-2 .7-2 1.4v8h-1.6v-8.5c0-.6.2-.9.7-1.2.6-.3 1.6-.5 2.9-.5 1.7 0 3.9.5 3.9 3v7.3h-1.5zm5.8 0h-1.6v-14.6h1.6v9.2l3.2-3.8a2.5 2.5 0 0 1 2.6-.8l-3 3.4c-.6.6-1.2 1.2-1.6 1.2v.3c.4 0 1.1.3 1.8 1.2l3.3 3.9s-.3.1-.7.1c-.6 0-1.4-.1-1.9-.8-.8-.9-3.6-4.5-3.6-4.5v5.2zm16.7-5.1c-.4 0-.9-.1-1.3-.1v5.3H52v-11.3c0-.6-.4-2.6 3.4-2.6 3.4 0 4.9 1.9 4.9 4.2 0 2.7-1.6 4.5-5.3 4.5m.5-7.7c-1.9 0-1.7 1.1-1.7 1.6v5c.3 0 .8.1 1.1.1 2.6 0 3.6-1.4 3.6-3.5 0-1.7-.9-3.2-3-3.2m10 13.1c-2.9 0-4.4-2.5-4.4-5.3s1.5-5.2 4.4-5.2c2.8 0 4.4 2.4 4.4 5.2s-1.5 5.3-4.4 5.3m-.1-9.6c-1.9 0-2.6 2-2.6 4.1s.8 4.5 2.7 4.5c2 0 2.7-2.1 2.7-4.1 0-2.2-.8-4.5-2.8-4.5m6.4 9.3v-14.5h1.6v14.5zm11-2.7c0 1.8-1.5 2.9-3.5 2.9-1.7 0-3.8-.9-3.8-3.1h.4c.8 0 1.3.4 1.5 1 .2.5.8 1.3 1.9 1.3.9 0 1.9-.6 1.9-1.7 0-2.5-5.4-2-5.4-5 0-1.7 1.5-2.7 3.4-2.7 1.6 0 3.3.8 3.3 2.7-.7.2-1.4 0-1.8-.9-.2-.4-.8-.9-1.5-.9h-.1c-1 0-1.8.6-1.8 1.6 0 2.1 5.5 1.5 5.5 4.8m3.6 2.7h-1.6v-14.6h1.6v9.2l3.2-3.8a2.5 2.5 0 0 1 2.6-.8l-3 3.4c-.6.6-1.2 1.2-1.6 1.2v.3c.4 0 1.1.3 1.8 1.2l3.3 3.9s-.3.1-.7.1c-.6 0-1.4-.1-1.9-.8-.8-.9-3.6-4.5-3.6-4.5v5.2zm8.6-11.8c-.7 0-1.2-.5-1.2-1.2 0-.6.5-1.2 1.2-1.2s1.2.5 1.2 1.2-.5 1.2-1.2 1.2m-.8 11.8v-10h1.6v10z" />
  </svg>
);
export default SvgPkoBpLogo;
